module.exports = __webpack_public_path__ + "img/70.9455569c.gif";